export { default } from './Search';
export { default as datamap } from './Search.datamap';
export type { PageData } from './Search.datamap';
